export const encodePayload = <T = unknown>(payload: T) => {
  const data = JSON.stringify(payload);
  return Buffer.from(data).toString('base64');
};

export const decodePayload = <T = unknown>(payload: string): T => {
  const data = Buffer.from(payload, 'base64').toString('utf-8');
  return JSON.parse(data);
};
